import { Component } from '@angular/core'

export const NOTE_IMAGE_VIEWER_CONTAINER = 'note-image-viewer-container'

@Component({
  selector: 'nns-note-image-viewer',
  template: `
    <div id="{{containerId}}"></div>
  `,
  styles: [`
    #note-image-viewer-container {
      display: none;
    }
`],
})

export class NoteImageViewerComponent {
  containerId = 'note-image-viewer-container';
}
